import React, { useState, useEffect, useCallback } from "react";
import Box from "@mui/material/Box";
import { Typography, Tabs, Tab } from '@mui/material';
import "./SFTPMain.css"
import SFTPSummary from "./SFTPTabs/SFTPSummary";
import SFTPFiles from "./SFTPTabs/SFTPFiles";
import SFTPSchema from "./SFTPTabs/SFTPSchema";
import SFTPCode from "./SFTPTabs/SFTPCode";
import SFTPHistory from "./SFTPTabs/SFTPHistory";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
      sx={{ p: 2 }}  // Optional padding style
    >
      {value === index && (
        <Typography component="div">{children}</Typography> 
      )}
    </Box>
  );
}

function SFTPMain({ 
  SFTPItemID, 
  SFTPName, 
  SFTPFiles: SFTPFilesData, 
  SFTPPythonCode, 
  SFTPNodeCode,
  SFTPSummaryText,
  SFTPColumnsData
}) {

  const [tabValue, setTabValue] = useState(0);  // use 0 for "SUMMARY" tab as default

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box 
    sx={{ width: '100%'}}  // Optional padding style
    >
        <Typography variant="h5" className="sftp-category-name">
                    {SFTPName || "Select an SFTP Connection"}
        </Typography>

        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          aria-label="sftp tabs" 
          centered
          sx={{
            minHeight: '35px',
            maxHeight: '35px',
            '& .MuiTab-root': {
              minHeight: '35px',
              padding: '5px 5px 5px 5px',
            },
          }}
        >
          <Tab label="Summary" id="tab-0" aria-controls="tabpanel-0" />
          <Tab label="Files" id="tab-1" aria-controls="tabpanel-1" />
          <Tab label="Schema" id="tab-2" aria-controls="tabpanel-2" />
          <Tab label="Code" id="tab-3" aria-controls="tabpanel-3" />
          {/* <Tab label="History" id="tab-4" aria-controls="tabpanel-4" /> */}
        </Tabs>
  
        <TabPanel value={tabValue} index={0}>
          <SFTPSummary SFTPItemID={SFTPItemID} SFTPName={SFTPName} SFTPFiles={SFTPFilesData} />
        </TabPanel>
        
        <TabPanel value={tabValue} index={1}>
          <SFTPFiles SFTPItemID={SFTPItemID} SFTPName={SFTPName} SFTPFiles={SFTPFilesData} />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <SFTPSchema 
            SFTPItemID={SFTPItemID} 
            SFTPName={SFTPName} 
            SFTPFiles={SFTPFilesData}
            SFTPSummaryText={SFTPSummaryText}
            SFTPColumnsData={SFTPColumnsData}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <SFTPCode 
            SFTPItemID={SFTPItemID} 
            SFTPName={SFTPName} 
            SFTPFiles={SFTPFilesData}
            pythonCode={SFTPPythonCode}
            nodejsCode={SFTPNodeCode}
          />
        </TabPanel>

        {/* <TabPanel value={tabValue} index={4}>
          <SFTPHistory SFTPItemID={SFTPItemID} SFTPName={SFTPName} />
        </TabPanel> */}

    </Box>
  );
}

export default SFTPMain;
